module.exports = __webpack_public_path__ + "static/pic04-fcb11a8e177ca71fb98a96f2735c96be.jpg";